import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-message-modal',
  templateUrl: './message-modal.component.html',
  styleUrls: ['./message-modal.component.css']
})
export class MessageModalComponent {
  @Input() errorMessage = 'error';
  @Input() changeImage = 1;
  isHidden: boolean;

  constructor() {
    this.isHidden = false;
  }

  closeModal() {
    this.isHidden = true;
  }
}
